export const FEATURES_CONSTANTS = {
  title: "Key benefits of Performance Labs and OEM Test Labs",
  list: [
    {
      label: "Comprehensive Testing Protocols",
      text: "Utilize advanced methodologies to evaluate mechanical shock, climatic resilience, impact resistance, and performance under extreme temperatures.",
    },
    {
      label: "OEM-Specific Evaluations",
      text: "Conduct tests tailored to meet the unique standards of various manufacturers, ensuring components align with OEM requirements.",
    },
    {
      label: "State-of-the-Art Equipment",
      text: "Employ cutting-edge technology and tools to simulate real-world conditions accurately.",
    },
    {
      label: "Accredited Testing Services",
      text: "Maintain certifications and accreditations to perform tests that meet international and industry-specific standards.",
    },
    {
      label: "Detailed Reporting",
      text: "Provide comprehensive analysis and documentation of test results, facilitating informed decision-making.",
    },
  ],
};
